import React from 'react';
import { trackViewedPage } from '../../../../utilities';
import type { NavigationTab } from '../../../../contracts';
import {
  NavigationLink,
  NavigationItemContainer,
  TriangleTab,
  NavigationLabel,
  PersonalDetailsIcon,
  PrivacySettings,
  FinancingTermsIcon,
  NotificationBellIcon,
  ReferralsIcon,
  NavigationIconContainer
} from './DesktopNavBar.styles';
import { NOTIFICATION_SETTINGS_PATH } from '../../../../tabs/NotificationSettings/routes/routePaths';
import { FINANCING_TERMS_PATH } from '../../../../tabs/FinancingTerms/routes/routePaths';
import { PERSONAL_DETAILS_PATH } from '../../../../tabs/PersonalDetails/routes/routePaths';
import { PRIVACY_SETTINGS_ROUTE } from '../../../../tabs/PrivacySettings/PrivacySettings';
import { REFERRALS_PATH } from '../../../../tabs/Referrals/routes/routePaths';

const icons: Record<string, React.ComponentType> = {
  [NOTIFICATION_SETTINGS_PATH]: NotificationBellIcon,
  [FINANCING_TERMS_PATH]: FinancingTermsIcon,
  [PERSONAL_DETAILS_PATH]: PersonalDetailsIcon,
  [PRIVACY_SETTINGS_ROUTE]: PrivacySettings,
  [REFERRALS_PATH]: ReferralsIcon
};

type OwnProps = {
  tab: NavigationTab;
};

export default function DesktopNavigationItem({ tab }: OwnProps) {
  const NavigationIcon = icons[tab.path];

  return (
    <NavigationLink
      to={tab.path}
      key={tab.path}
      activeClassName="activeTab"
      onClick={() => trackViewedPage(tab.path)}
    >
      <NavigationItemContainer>
        <NavigationIconContainer>
          <NavigationIcon />
        </NavigationIconContainer>
        <NavigationLabel>{tab.displayName}</NavigationLabel>
        <TriangleTab />
      </NavigationItemContainer>
    </NavigationLink>
  );
}
